export default "__VITE_ASSET__CeNpBew$__"